/**
 * Pad an array to a given length.
 *
 * @param inputArray: Original array.
 * @param length: Length of the new array.
 * @param defaultValue: Default value to use, is none is given the last value from the
 *  original array will be used.
 * @returns A new array with the given length.
 */
export const paddedArray = (inputArray, length, defaultValue = undefined) => {
  defaultValue = defaultValue || inputArray[inputArray.length - 1];

  return Array(length)
    .fill(undefined)
    .map((_, idx) => inputArray[idx] || defaultValue);
};
